
import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import scroll from '@/mixins/scroll'
import goodsCard from './components/goodsCard.vue'
import NoticeBar from '@/components/NoticeBar/index.vue'
import {
  getPartnerCategoryList,
  getCyStoreGoodsList,
  getStoreShoppingCart,
  ShopGoodsInfoDto,
  PartnerCategoryList,
} from '@/api/industryMall'
import { LoginReturnDataDto } from '@/utils/h5ToApp'
import { TabDto } from '@/api/goodsModule'

@Component({
  name: 'MallCategory',
  components: {
    goodsCard,
    NoticeBar
  }
})
export default class mallCategory extends Mixins(scroll) {
  @Getter partnerCompanyId!: string
  @Getter companyId!: string
  @Getter tabModules!: Array<TabDto>
  // @Getter topSafetyHeight!: number
  @Getter info!: LoginReturnDataDto

  params = {
    pageIndex: 1,
    pageSize: 10,
    partnerCompanyId: '', // 合作方企业编号
    keyword: '',
    terraceCategoryId: '', // 平台商品分类表编号
    companyId:''

  }
  refreshing = false
  loading = false
  finished = false
  tabActive = 0 // 1级分类key
  active2Key = 0 // 2级分类key
  active3Key = 0 // 3级分类key
  tabs: PartnerCategoryList[] = []
  category: PartnerCategoryList = {}

  goodsList: ShopGoodsInfoDto[] = []

  category3List: PartnerCategoryList[] = []

  show = false

  contentOverlayShow = false

  showLoading = false
  targetCategoryId = '' // 从分类导航跳转带来的分类id
  isActivated = false

  get isTabModule () {
    return this.tabModules.find(t => t.route === '/mallCategory')?.isShow ?? true
  }

  handleClickOverlay() {
    this.contentOverlayShow = false
  }

  categoryClick(index) {
    this.tabActive = index
    this.getCategory(index)
    this.show = false
  }
  popupClick() {
    this.show = true
    this.contentOverlayShow = false
  }

  created() {
    this.params.partnerCompanyId = this.partnerCompanyId
    this.params.companyId = this.companyId
    this.init()
  }

  mounted () {
    this.$addScrollListener('.goods-box')
  }

  activated() {
    if (this.isActivated) {
      const categoryId = this.$route.query.categoryId as string
      if (categoryId) {
        this.findCategoryIndex()
        this.refreshing = true
        this.setTerraceCategoryIdAndRefreshData()
      }
      this.$setScrollY()
      this.refreshShoppingGoodsCount()
    } else {
      this.isActivated = true
    }
  }

  deactivated () {
    this.$removeScrollListener()
  }

  async init() {
    await this.getPartnerCategoryList()
    this.setTerraceCategoryIdAndRefreshData()
  }

  setTerraceCategoryIdAndRefreshData () {
    if (this.active3Key) {
      this.params.terraceCategoryId = this.category.children[this.active2Key].children[this.active3Key > 0 ? (this.active3Key - 1) : 0].hierarchyId
    } else if (this.category.children[this.active2Key]) {
      this.params.terraceCategoryId = this.category.children[this.active2Key].hierarchyId
    } else {
      this.params.terraceCategoryId = this.category.hierarchyId
    }
    this.getCyStoreGoodsList()
  }

  onRefresh() {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getCyStoreGoodsList()
  }

  onLoad() {
    this.params.pageIndex++
    this.getCyStoreGoodsList()
  }

  dataInit() {
    this.params.pageIndex = 1
    this.goodsList = []
    this.showLoading = true
  }

  /**
   * 去历史记录页
   */
  toHistory() {
    this.$router.push({
      path: '/MallSearchHistory',
      query: {
        searchType: '1',
        storeId: this.partnerCompanyId
      }
    })
  }

  /**
   * 获取商品列表
   * @param {boolean} dataInit 是否初始化数据
   */
  getCyStoreGoodsList(dataInit = false) {
    dataInit && this.dataInit()
    getCyStoreGoodsList({ ...this.params })
      .then((res) => {
        if (this.refreshing) {
          this.goodsList = []
        }
        this.goodsList = this.goodsList.concat(res.data.records)
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
      .catch(() => {
        this.finished = true
      })
      .finally(() => {
        this.loading = false
        this.refreshing = false
        this.showLoading = false
      })
  }

  filterCategoryList(list: Array<any>) {
    return list.filter((item) => {
      if (item.children) {
        item.children = this.filterCategoryList(item.children)
      }
      return Number(item.goodsCount) !== 0
    })
      }

  /**
   * 获取合作方下产业商城分类-新
   */
  async getPartnerCategoryList() {
    try {
      let res = await getPartnerCategoryList({
        partnerCompanyId: this.partnerCompanyId,
        isPage: false,
        form: 1
      })
      // this.tabs = res.data
      this.tabs = this.filterCategoryList(res.data)
      this.findCategoryIndex()
    } catch (error) {
      this.showLoading = false
      console.log(error)
    }
  }

  // 递归查找目标分类的1、2、3级分类对应的index
  findCategoryIndex () {
    const categoryId = this.$route.query.categoryId as string
    this.targetCategoryId = categoryId
    let indexArray = []
    function loopFn(arr: Array<PartnerCategoryList>, indexArr: Array<number>) {
      const targetIndex = arr.findIndex(i => i.categoryId === categoryId)
      if (targetIndex > -1) {
        indexArray = [...indexArr, targetIndex]
        return
      }
      arr.forEach((c, index) => {
        if (c.children) loopFn(c.children, [...indexArr, index])
      })
    }
    loopFn(this.tabs, [])
    console.log('indexArray ***', indexArray)
    if (indexArray.length > 0) {
      this.tabActive = indexArray[0]
      this.active2Key = indexArray[1] || 0
      this.active3Key = indexArray.length === 3 ? (indexArray[2] + 1) : 0
    }
    this.category = this.tabs[this.tabActive]
    if (this.category.children[this.active2Key]) {
      // 筛选三级分类a
      this.category3List =
        this.category.children[this.active2Key].children &&
        this.category.children[this.active2Key].children.map((item) => item)
      this.category3List.unshift({
        categoryId: '1',
        categoryName: '全部',
        hierarchyId: this.category.children[this.active2Key].hierarchyId
      })
    }
  }

  // 一级分类点击
  getCategory(index: number) {
    // if (this.active === index) return false
    this.category = this.tabs[index]

    this.category3List = []
    if (this.category.children[0] && this.category.children[0].children) {
      // 筛选三级级分类
      this.category3List = this.category.children[0].children.map(
        (item) => item
      )

      this.category3List.unshift({
        categoryId: '1',
        categoryName: '全部',
        hierarchyId: this.category.children[0].hierarchyId
      })
    }

    this.active2Key = 0
    this.active3Key = 0
    // 一级切换每次都请求第一个二级分类
    if (this.category.children && this.category.children.length) {
      this.params.terraceCategoryId = this.category.children[0].hierarchyId
    } else {
      this.params.terraceCategoryId = this.category.hierarchyId
    }
    this.getCyStoreGoodsList(true)
  }

  // 二级分类点击
  getCategory2(index: number) {
    // if (this.active2Key === index) return false
    this.active2Key = index
    this.active3Key = 0

    this.params.terraceCategoryId = this.category.children[index].hierarchyId
    this.category3List = []
    if (
      this.category.children[index].children &&
      this.category.children[index].children.length
    ) {
      // 筛选三级分类
      this.category3List =
        this.category.children[index].children &&
        this.category.children[index].children.map((item) => item)
      this.category3List.unshift({
        categoryId: '1',
        categoryName: '全部',
        hierarchyId: this.category.children[index].hierarchyId
      })
    }

    this.getCyStoreGoodsList(true)
  }

  handle3Category(item, index) {
    // if (this.active3Key === index) return
    this.active3Key = index
    this.params.terraceCategoryId = item.hierarchyId
    this.getCyStoreGoodsList(true)
    this.contentOverlayShow = false
  }

  /** 刷新商品在购物车中的数量 */
  refreshShoppingGoodsCount () {
    getStoreShoppingCart({
      partnerCompanyId: this.info.partnerCompanyId,
      pageIndex: 1,
      pageSize: 100
    }).then((res) => {
      const shoppingGoods = []
      res.data.records.forEach(shop => {
        shoppingGoods.push(...shop.goodsPackageList)
      })
      const goods = []
      shoppingGoods.forEach(good => {
        if (Number(good.isValid)) {
          goods.push({
            goodsId: good.goodsId,
            packageId: good.packageId,
            orderQuantity: Number(good.orderQuantity),
            goodsName: good.goodsName
          })
        }
      })
      this.goodsList.forEach(good => {
        if (!good.isMultiSpec) {
          good.packageList.forEach((pack: any, packIndex) => {
            const targetGood = goods.find(id => id.goodsId === pack.goodsId && id.packageId === good.packageList[packIndex].packageId)
            if (targetGood) {
              good.packageList[packIndex].orderQuantity = targetGood.orderQuantity
            } else {
              // 购物车删除的商品
              good.packageList[packIndex].orderQuantity = 0
            }
          })
        }
      })
    })
  }
}
